// HTML → leesbare platte tekst MET regeleinden.
// `textContent` op een geparsed document gooit alle blok-structuur weg
// (<p>A</p><p>B</p> → "AB") — daarom eerst blok-elementen naar newlines
// vertalen en dan pas de tekst eruit halen.
export function htmlToPlainText(html) {
  const s = String(html || '');
  if (!/[<>]/.test(s)) return s.replace(/\n{3,}/g, '\n\n').trim();
  const withBreaks = s
    .replace(/<\s*br\s*\/?\s*>/gi, '\n')
    .replace(/<\s*li[^>]*>/gi, '\n- ')
    .replace(/<\s*\/(p|div|li|h[1-6]|tr|table|ul|ol|blockquote)\s*>/gi, '\n')
    .replace(/<\s*(p|h[1-6]|blockquote)[^>]*>/gi, '\n');
  const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
  return (doc.body?.textContent || '')
    .replace(/ /g, ' ')
    .split('\n').map((l) => l.trim()).join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
